import cn from 'classnames'
import React, { ComponentProps } from 'react'

type LockedIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function LockedIcon(props: LockedIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('LockedIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.99984 5.33337H3.6665C3.11422 5.33337 2.6665 5.78109 2.6665 6.33337V13.6667C2.6665 14.219 3.11422 14.6667 3.6665 14.6667H12.3332C12.8855 14.6667 13.3332 14.219 13.3332 13.6667V6.33337C13.3332 5.78109 12.8855 5.33337 12.3332 5.33337H11.9998M3.99984 5.33337C3.99984 5.33337 3.99984 1.33337 7.99984 1.33337C11.9998 1.33337 11.9998 5.33337 11.9998 5.33337M3.99984 5.33337H11.9998M7.99984 9.33337V11.3334"
        stroke="#697080"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
